import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";
const videoConstraints = {
  width: 600,
  height: 500,
  //facingMode: "user",
  //facingMode: { exact: "environment" },
  //aspectRatio: 1.6666666667,
  screenshotQuality: 1,
  facingMode: FACING_MODE_USER,
};

const Camera = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate("");
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);
  const [imgSrc02, setImgSrc02] = useState(null);
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);

  const handleClick = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER,
    );
  }, []);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);

    const formData = new FormData();
    formData.append("uploadFile", imageSrc);
    formData.append("localParth", props.setParthValue); //1 is (upload/admin_passports/), 2 is (upload/camera/)

    axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "camera", formData).then((res) => {
          if (res?.data?.status === 200) {
            console.log(res.data.message);
            props.setCameraValue((prev) => ({
              ...prev,
              cameraValue: res.data.message,
              changeValue: props.setChangePage,
            }));
            setImgSrc02(res.data.message); //image path
          } else {
            swal("Failed", res.data.message, "warning");
            console.log(res.data.message);
          }
        });
      } catch (error) {
        swal("Oops!", "Image Capture Failed", "error");
        console.log(error.response.data);
      }
    });
  }, [webcamRef, setImgSrc]);

  const deletImage = () => {
    let imgSrca = btoa(imgSrc02); //convert the link to base64 encode
    axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.delete(BASE_URL + "camera/" + imgSrca).then((res) => {
          if (res?.data?.status === 200) {
            console.log(res.data.message);

            setImgSrc("");
            swal("Success", "Image Deleted Successfully", "success");

            navigate("/admin/dashboard");
          } else {
            swal("Failed", res.data.message, "warning");
            console.log(res.data.message);
          }
        });
      } catch (error) {
        swal("Oops!", "Image Deleting Failed", "error");
        console.log(error.response.data);
      }
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 mt-4">
          {/* WebCarm Camera */}
          <div className="col-12" onClick={capture}>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{
                ...videoConstraints,
                facingMode,
              }}
              width="100%"
              height="100%"
            />
          </div>
        </div>
        <div className="col-md-12 mt-4">
          <div className="col-12">
            <button className="btn btn-primary col-12" onClick={capture}>
              Capture photo
            </button>
          </div>
          <div className="col-12 mt-2">
            <button className="btn btn-info col-12" onClick={handleClick}>
              Switch Camera
            </button>
          </div>
          <div className="col-12 mt-2">
            <button className="btn btn-danger col-12" onClick={deletImage}>
              Delete photo
            </button>
          </div>
        </div>
        <div className="col-md-12 mt-4">
          {/* WebCarm Result */}
          <div className="col-12">
            {imgSrc && (
              <img src={imgSrc} alt="test" width="100%" height="100%" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Camera;
